import Button from '../../../Button'

function AppointmentFollowUpsButton({ fixture, onOpen }) {
  function handleClick() {
    onOpen(fixture.id)
  }

  return (
    <Button.Outlined
      qaName={fixture.qaName}
      text={fixture.text}
      onClick={handleClick}
    />
  )
}

export default AppointmentFollowUpsButton
